<template>
  <div id="searchCity">

    <div id="searchCity-parent">
      <div id="search">
        <img src="../../../assets/icon/search.jpg" id="search-img"/>
        <div id="search-text-view">
          <input type="text" id="search-text2"
                 style="color:#BDBDBD"
                 value="请输入城市进行搜索"
                 onfocus="if(value=='请输入城市进行搜索'){value=''};style='color:#191919'"
                 onblur="if(value==''){value='请输入城市进行搜索'};style='color:#BDBDBD'"
                 @input="searchTextChange"/>
        </div>
        <img v-on:click="close" src="../../../assets/icon/close.png" id="search-close" />

        <div class="sparator search-sparator"></div>
      </div>

      <div v-for="(city,cityIndex) in showData" class="parentCell">

        <div class="wrapper">
          <div @click="selectedCity(city.name, city, false)"
               v-bind:id="city.name" class="cell">
            {{city.name}}
          </div>
          <div v-if="(cityIndex < (showData.length-1)) || isShowChildCity2[city.name]" class="sparator"></div>
        </div>

        <div class="wrapper" v-show=" isShowChildCity2[city.name] " v-for="(childCity,childCityIndex) in city.childCitys">
          <div @click="selectedCity(childCity.name, childCity, true)" class="cell cell-child">
            {{childCity.name}}
          </div>
          <div v-if="(cityIndex < showData.length-1) || childCityIndex < city.childCitys.length-1" class="sparator sparator-child"></div>
        </div>

      </div>

    </div>


  </div>
</template>

<script>
  import bus from '@/js/eventBus'
  import api from '@/api/common/api.common'
  export default {
    props: ['cityData'],
    computed: {
//      cityData () {
//        return this.$store.state.citys.cityData
//      }
    },
    data () {
      return {
        showData: [],
        isShowChildCity2: {},
      }
    },
    mounted () {
      document.getElementById('search-text2').focus()
    },
    methods: {
      searchTextChange (sender) {

        var self = this
        var val = sender.srcElement.value
        var cityData = []
        var showChildCity = {}
        if (val.length === 0) {
          this.showData = cityData
          this.isShowChildCity2 = showChildCity
          return
        }

        for (var x in Object.keys(this.cityData)) {
          var cityArr = this.cityData[Object.keys(this.cityData)[x]]
          var citys = new Set(cityArr)

          citys.forEach(function (city) {
            var cityNameSpell = city.cityNameSpell.replace(/\s+/g,"")
            if (city.name.indexOf(val) !== -1 || cityNameSpell.indexOf(val) !== -1) {

              cityData.push(city)

              if (city.hasOwnProperty('childCitys')) {
                showChildCity[city.name] = false
              }

            } else {
              for (var z in city.childCitys) {
                var childCity = city.childCitys[z]

                // var cityNameSpell2 = childCity.regionalismNameSpell.replace(/\s+/g,"")
                var cityNameSpell2 = childCity.regionNamePingyin.replace(/\s+/g,"")
                if (childCity.name.indexOf(val) !== -1 || cityNameSpell2.indexOf(val) !== -1) {

                  var newCity = JSON.parse(JSON.stringify(childCity))
                  // newCity.name = newCity.regionalismName + ', ' + newCity.cityName
                  newCity.name = newCity.regionName + ', ' + newCity.cityName


                  cityData.push(newCity)
                }
              }
            }
          })

        }
        this.showData = cityData
        this.isShowChildCity2 = showChildCity
      },
      close () {
        bus.$emit('closeSearchCity', false)
      },
      selectedCity (cityName, city, isChildCity) {
        var isShow = this.isShowChildCity2[cityName]

        if (isShow !== undefined && !isChildCity) {

          delete this.isShowChildCity2.cityName
          this.isShowChildCity2[cityName] = !isShow
        } else {
//          this.utils.alert('选择了:' + cityName)
          this.cacheCity(city,this)
        }
      },
      cacheCity(city,self){
        var data = {}
        data.regionlismCityId = city.regionId
        api.cacheLocation(data,function (respond) {
          self.$store.dispatch('setUserCity' , city)
          localStorage.setItem('cacheKey', respond.body.data['cacheKey'])

          delete city.childCitys
          var cityStr = JSON.stringify(city)
          localStorage.setItem('locationCity', cityStr)
          self.$router.push('/')

        })
      }
    }



  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';
  #searchCity {
    background-color: white;
    display: inline;
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    top: 0px;
    z-index: 666;
    overflow: scroll;
  }

  #search {
    height: pxToRem(100px);
    position: relative;
  }
  #search-img {
    display: inline-block;
    margin-left: pxToRem(60px);
    margin-top: pxToRem(35px);
    height: auto;
    width: pxToRem(30px);
  }
  #search-text-view {
    display: inline-block;
    position: absolute;
    left: pxToRem(124px);
    width: 65%;
    top: 0px;
    bottom: 0px;
  }
  #search-text2 {
    margin-top: pxToRem(32px);
    line-height: pxToRem(32px);
  }
  #search-close {
    position: absolute;
    right: pxToRem(74px);
    width: pxToRem(20px);
    height: auto;
    top: pxToRem(40px);
  }

  #searchCity-parent {
    position: relative;
    overflow: auto;
    isVertical: true;
  }
</style>



// WEBPACK FOOTER //
// searchCity.vue?2fbec968